export default __webpack_public_path__ + "static/media/COTK-Full-Logo-White-Large.82ebff26.png";